/* Who could have taken a missed walk-in, counted service by service.
 *
 * Two places ask it. The sheet asks at the moment of the loss and stamps the
 * answer on the row (`staff_able`, `staff_able_by_service`); History asks it
 * again afterwards, off the turns, to say how many of them were on the floor
 * and how many of those were free. The two used to count different people:
 * the stamp counted the rotation, History counted everybody with a turn, so a
 * technician on their own clients made History read "7 of 6" (Kevin,
 * 2026-11-01 — Faith, own clients, acrylics). Both now count the rotation
 * only, for the reason rules/own-clients.js gives: a walk-in does not go to
 * somebody on their own clients, so they are nobody's answer to it.
 *
 * And the union alone hides the answer to a party after two things. "6 could
 * take it" for an acrylic and a gel pedicure is six who do acrylics and four who
 * do pedicures, and the four is the number that says which technician to add.
 * So each named service is counted on its own as well.
 *
 * Pure; this file imports nothing.
 */

function does(staff, serviceId) {
  return !!staff && (staff.serviceIds || []).indexOf(serviceId) !== -1;
}

/* At the moment of the loss: how many of `staff` — the rotation, as
 * { id, serviceIds } — do each of `serviceIds`. An object keyed by service id;
 * empty when nothing was named, since "everybody who does anything" is the union
 * again and not a per-service fact. */
export function ableByService(serviceIds, staff) {
  var out = {};
  (serviceIds || []).forEach(function (sid) {
    out[sid] = (staff || []).filter(function (s) { return does(s, sid); }).length;
  });
  return out;
}

/* Afterwards, off the turns.
 *
 *   wanted   the service ids the party named; empty is "did not say", and then
 *            everybody in the rotation could have been the answer.
 *   working  everybody on the floor at that moment:
 *            { id, name, busy, serviceIds, ownClients }
 *
 * Returns the union — `able`, `free`, `freeNames` — and `byService`, one entry
 * per named service in the order named: { serviceId, able, free, freeNames }.
 * Somebody who does two of the things counts once in the union and once under
 * each service. `working` is the whole floor, own clients included, because it
 * sits beside the count of everybody marked in. */
export function floorRead(wanted, working) {
  var ids = wanted || [];
  var rotation = (working || []).filter(function (w) { return !w.ownClients; });

  function tally(can) {
    var able = rotation.filter(can);
    var free = able.filter(function (w) { return !w.busy; });
    return {
      able: able.length,
      free: free.length,
      freeNames: free.map(function (w) { return w.name; })
    };
  }

  var union = tally(function (w) {
    return !ids.length || ids.some(function (sid) { return does(w, sid); });
  });
  return {
    working: (working || []).length,
    able: union.able,
    free: union.free,
    freeNames: union.freeNames,
    byService: ids.map(function (sid) {
      var t = tally(function (w) { return does(w, sid); });
      return { serviceId: sid, able: t.able, free: t.free, freeNames: t.freeNames };
    })
  };
}
